import React from 'react';
import cn from 'classnames';

import {ServerAlertRuleSeverity} from 'features/server/model/ServerAlertRule/IServerAlertRule';
import {getServerAlertRuleSeverityLabel} from 'features/server/lib/serverAlertRuleHelper';

import styles from './ServerIncidentSeverityBadge.module.scss';

interface IServerIncidentSeverityBadgeProps {
    severity: ServerAlertRuleSeverity,
    className?: string,
}

const ServerIncidentSeverityBadge: React.FC<IServerIncidentSeverityBadgeProps> = ({severity, className}) => (
    <span className={cn(styles.severity, styles[severity], className)}>
        {getServerAlertRuleSeverityLabel(severity)}
    </span>
);

export default ServerIncidentSeverityBadge;
